<template>
  <div class="wizard-row">
    <eg-input
      :value="value"
      :placeholder="placeholder"
      :size="size"
      :show-validation="false"
      :state="hasValidationError ? 'error' : 'default'"
      @input="$emit('update:value', $event)"
    />
    <div class="actions">
      <eg-button
        v-if="hasDelete"
        v-b-tooltip.hover
        :title="$t('common.delete')"
        type="ordinary"
        size="small"
        icon="delete"
        :icon-color="deleteIconColor"
        :disabled="!canShowDelete"
        @click="handleDelete"
      />
      <eg-button
        v-if="hasDuplicate"
        v-b-tooltip.hover
        :title="$t('common.duplicate')"
        type="ordinary"
        size="small"
        icon="duplicate-copy"
        icon-color="var(--color-icon-neutral-neutral)"
        @click="handleDuplicate"
      />
      <eg-button
        v-if="hasToggle"
        type="ordinary"
        size="small"
        icon="chevron-down"
        icon-size="medium"
        :icon-color="toggleIconColor"
        :class="{ expanded: isExpanded }"
        @click="handleToggle"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "WizardRow",
  components: {},
  props: {
    value: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    size: { type: String, default: "small" },
    isExpanded: { type: Boolean, default: false },
    canShowDelete: { type: Boolean, default: true },
    hasValidationError: { type: Boolean, default: false },
    // Optional function handlers; if provided, buttons render automatically
    onDelete: { type: Function, default: null },
    onDuplicate: { type: Function, default: null },
    onToggle: { type: Function, default: null },
  },
  emits: ["update:value", "delete", "duplicate", "toggle"],
  computed: {
    hasDelete() {
      return !!this.onDelete || !!this.$listeners.delete;
    },
    hasDuplicate() {
      return !!this.onDuplicate || !!this.$listeners.duplicate;
    },
    hasToggle() {
      return !!this.onToggle || !!this.$listeners.toggle;
    },
    deleteIconColor() {
      // Use different icon color when button is disabled
      return this.canShowDelete
        ? "var(--color-icon-neutral-neutral)"
        : "var(--color-icon-neutral-disabled)";
    },
    toggleIconColor() {
      return this.isExpanded
        ? "var(--color-icon-neutral-default)"
        : "var(--color-icon-neutral-neutral)";
    },
  },
  methods: {
    handleDelete() {
      if (this.onDelete) return this.onDelete();
      this.$emit("delete");
    },
    handleDuplicate() {
      if (this.onDuplicate) return this.onDuplicate();
      this.$emit("duplicate");
    },
    handleToggle() {
      if (this.onToggle) return this.onToggle();
      this.$emit("toggle");
    },
  },
};
</script>

<style scoped lang="scss">
.wizard-row {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  column-gap: 16px;
}
.actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
// Rotate the icon when expanded using ::v-deep
::v-deep .eg-new-button .eg-icon {
  transition: transform 0.2s ease;
}
::v-deep .eg-new-button.expanded .eg-icon {
  transform: rotate(180deg);
}
</style>
